export const DEFAULT_QUICK_REPORT_TEMPLATE_CODE = 'growth_pulse';

/** TODO(overview-pdf-be): použiť pri create overview reportu keď BE pridá template. */
export const OVERVIEW_REPORT_TEMPLATE_CODE = 'overview';

export type QuickReportScope = 'full' | 'performance' | 'overview';

/**
 * The landscape export prints a Reactions page for every network, and the API
 * narrows a report's overview to the metrics its sections asked for. Without
 * these the page would come back empty on Instagram, LinkedIn and TikTok, and
 * all zeros on Facebook.
 */
export const LANDSCAPE_EXPORT_REACTION_METRICS = [
  'reactions_like',
  'reactions_love',
  'reactions_haha',
  'reactions_wow',
  'reactions_sad',
  'reactions_angry',
  'likes',
  'comments',
  'shares',
  'saved',
  'replies',
  'reposts',
];
